import { render, staticRenderFns } from "./CreditorDataSection.vue?vue&type=template&id=fc1c12f8"
import script from "./CreditorDataSection.vue?vue&type=script&lang=js"
export * from "./CreditorDataSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports